import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MsalBroadcastService, MsalInterceptor, MsalService } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { Location } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { AuthConfig } from '../configuration/auth.config';

export const BYPASS_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

@Injectable()
export class DfmInterceptor extends MsalInterceptor implements HttpInterceptor {
  constructor(authService: MsalService, location: Location, msalBroadcastService: MsalBroadcastService) {
    super(
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map(AuthConfig.protectedApis.map((apis) => [apis.url, [apis.scope]])),
        authRequest: {
          redirectUri: `${environment.authentication.redirectUrl}`,
        },
      },
      authService,
      location,
      msalBroadcastService,
      document,
    );
  }

  override intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(BYPASS_INTERCEPTOR)) {
      return next.handle(request);
    }

    return super.intercept(request, next);
  }
}
